import MultiRing, { type MultiRingProps } from './MultiRing';

export type { MultiRingProps };
export default MultiRing;
